import { fetchAttributes } from '@/features/events/eventTags';
import { useQuery } from '@tanstack/react-query';

const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const eventAttributeCatalogKeys = {
  all: ['event-attribute-catalog'] as const,
};

export function useEventAttributeCatalog(enabled = true) {
  return useQuery({
    queryKey: eventAttributeCatalogKeys.all,
    queryFn: fetchAttributes,
    staleTime: FIVE_MINUTES_MS,
    enabled,
  });
}
